import loader from './svg/loader.svg';

const SVG_ICONS_PRELOADER = {
  LOADER: loader,
};

export default SVG_ICONS_PRELOADER;
